import { useState } from 'react'
import { Box, Button, HStack, Textarea, Text } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown'
import { FiEdit2 } from 'react-icons/fi'
import ProfileCard from '../districtProfile/ProfileCard'
import { useUpdateListNotes } from '../../hooks/useContactList'
import { proseContentCss } from '../../theme/proseStyles'

export function NotesPanel({ listId, notes }: { listId: string; notes?: string }) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(notes ?? '')
  const update = useUpdateListNotes(listId)

  const save = () => {
    update.mutate(draft)
    setEditing(false)
  }

  return (
    <ProfileCard eyebrow="Notes" title="Organizer notes">
      {editing ? (
        <Box mt={3}>
          <Textarea value={draft} onChange={e => setDraft(e.target.value)} rows={6} placeholder="Why this list exists, how to use it…" />
          <HStack mt={2} justify="flex-end">
            <Button size="sm" variant="ghost" onClick={() => { setDraft(notes ?? ''); setEditing(false) }}>Cancel</Button>
            <Button size="sm" colorPalette="brand" onClick={save} loading={update.isPending}>Save</Button>
          </HStack>
        </Box>
      ) : (
        <Box mt={3}>
          <HStack justify="space-between" align="flex-start">
            <Box flex="1" fontSize="sm" color="gray.700" css={proseContentCss}>
              {notes ? <ReactMarkdown>{notes}</ReactMarkdown> : <Text color="gray.400">No notes yet.</Text>}
            </Box>
            <Button size="sm" variant="ghost" onClick={() => setEditing(true)}><FiEdit2 />Edit</Button>
          </HStack>
        </Box>
      )}
    </ProfileCard>
  );
}
